import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "33",
  height: "32",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M29.833 16c0 7.363-5.97 13.333-13.333 13.333S3.167 23.363 3.167 15.999 9.136 2.666 16.5 2.666s13.333 5.97 13.333 13.333m-7.96-4.041a1 1 0 0 1 0 1.414l-6.666 6.667a1 1 0 0 1-1.414 0l-2.667-2.667a1 1 0 1 1 1.414-1.414l1.96 1.96 2.98-2.98 2.98-2.98a1 1 0 0 1 1.414 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }